import { productDumpApi } from 'apiConnector/productDump';
import { ProductDumpApiContext } from 'components/common-form/contexts/ProductDumpContext';
import { TopTabs } from 'components/common-form/sidePanel/topTabs';
import { Status } from 'components/PostTrade/Addon/components/SidePanel/status';
import { FC } from 'react';

import { GenericErrorBoundary } from '../../../../common-form/builder/form/GenericErrorBoundary';
import { GreeksFeesMetricsTabContent } from './infos/QuoteDetails';
import { MainContent } from './MainContent';
import type { SidePanelProps } from './SidePanel.connect';
import { connectSidePanel } from './SidePanel.connect';

export const Component: FC<SidePanelProps> = ({ tabId, hasGreeks, hasFees, hasMetrics, activeTab, selectTab }) => {
  return (
    <ProductDumpApiContext.Provider value={productDumpApi}>
      <TopTabs
        activeTab={activeTab}
        handleChangeOfActiveTab={selectTab}
        hasRegulatory={false}
        regulatoryAdditionalHeaderContent={null}
        hasAdvisory={false}
        hasFees={hasFees}
        hasGreeks={hasGreeks}
        hasMetrics={hasMetrics}
        hasBackTest={false}
        hasMissedDealFeedBack={false}
        summaryTabContent={
          <GenericErrorBoundary key={tabId} context={{ tabId: tabId }}>
            <div className="d-flex flex-column h-100">
              <Status tabId={tabId} workspaceType="postTrade" />
              <MainContent className="overflow-y-auto flex-grow-1" tabId={tabId} />
            </div>
          </GenericErrorBoundary>
        }
        backTestTabContent={null}
        regulatoryTabContent={null}
        advisoryTabContent={null}
        missedDealFeedBackContent={null}
        greeksFeesMetricsTabContent={
          <GenericErrorBoundary key={tabId} context={{ tabId: tabId }}>
            <GreeksFeesMetricsTabContent tabId={tabId} workspaceType="postTrade" />
          </GenericErrorBoundary>
        }
      />
    </ProductDumpApiContext.Provider>
  );
};

export const SidePanel = connectSidePanel(Component);

SidePanel.displayName = 'AddonSidePanel';
